import PaginatedResourceController from './PaginatedResourceController';
import InfiniteResultsCollector from './InfiniteResultsCollector';
import ResourceLoaderController from './ResourceLoaderController';
import PaginationController from './PaginationController';
import DelayedExecutorController from './DelayedExecutorController';
import InfiniteTemplateResultsController from './InfiniteTemplateResultsController';

function install(Vue) {
  Vue.component(PaginatedResourceController.name, PaginatedResourceController);
  Vue.component(InfiniteResultsCollector.name, InfiniteResultsCollector);
  Vue.component(ResourceLoaderController.name, ResourceLoaderController);
  Vue.component(PaginationController.name, PaginationController);
  Vue.component(DelayedExecutorController.name, DelayedExecutorController);
  Vue.component(InfiniteTemplateResultsController.name, InfiniteTemplateResultsController);
}

export default {
  install,
};
